import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/details/isBillable`;

export const ROUTE: RouteDefinition = `${baseRoute}/details/isBillable`;

export const URL = (): RouteDefinition => `${baseRoute}/details/isBillable`;
